import { Alert, AlertTitle, Box, Button, Typography } from '@mui/material';
import Grid2 from '@thirdparty-framework/mui/material/Grid';
import { useLocalization, useUserAccess } from '@ui-framework/index';
import React, { forwardRef, useState } from 'react';

import DispatchHistory from './DispatchHistory';
import DispatchDetails from './DispatchDetails';

const DISPATCH_PROGRESS_SUMMARY_HEADING = {
  hide: 'Hide Display Dispatch Summary',
  show: 'Show Display Dispatch Summary',
};

const ServiceAdministratorDispatch = forwardRef(
  (
    {
      dispatch,
      serviceJob,
      assignedServiceProvider,
      isJobAssignedToSP,
      ...props
    },
    ref,
  ) => {
    const userAccess = useUserAccess();
    const { formatMessage } = useLocalization();
    const [showSummary, setShowSummary] = useState(false);
    const toggleSummary = () => {
      setShowSummary(prevState => !prevState);
    };

    let showDispatch = false;
    if (userAccess.isSA() || userAccess.isAdmin()) {
      showDispatch = !isJobAssignedToSP || showSummary;
    }

    if (!dispatch?.id) {
      return (
        <Grid2 container sx={{ m: 1 }}>
          <Typography>No dispatch information to display</Typography>
        </Grid2>
      );
    }

    return (
      <Grid2 xs={12} container alignItems="center" ref={ref} rowSpacing={1}>
        <Grid2 xs={12}>
          <DispatchDetails
            formPermissions={props?.formPermissions}
            dispatch={{
              ...dispatch,
            }}
            serviceJob={serviceJob}
            assignedServiceProvider={assignedServiceProvider}
          />
        </Grid2>
        <Grid2 xs={12}>
          {isJobAssignedToSP && (
            <>
              <Alert xs={12} severity="success">
                <AlertTitle>
                  {`${formatMessage({
                    id: 'JOB_ASSIGNED_TO_SP',
                    defaultMessage: `Job is assigned to`,
                  })}${' '}${assignedServiceProvider?.name || 'a Service Provider'}`}
                </AlertTitle>
              </Alert>
              {(userAccess.isSA() || userAccess.isAdmin()) && (
                <Button variant="text" onClick={toggleSummary}>
                  {showSummary
                    ? DISPATCH_PROGRESS_SUMMARY_HEADING.hide
                    : DISPATCH_PROGRESS_SUMMARY_HEADING.show}
                </Button>
              )}
            </>
          )}
          {showDispatch && dispatch?.id && (
            <Box>
              <DispatchHistory serviceJob={serviceJob} dispatch={dispatch} />
            </Box>
          )}
        </Grid2>
      </Grid2>
    );
  },
);

export default ServiceAdministratorDispatch;
